import { useQuery } from '@apollo/client';

import {
  GetToolboxIntegrationsCountDocument,
  GetToolboxIntegrationsCountQueryVariables,
} from './getToolboxIntegrationsCount.gql';

const useGetToolboxIntegrationsCount = (
  filters: GetToolboxIntegrationsCountQueryVariables['filters'] = {},
) => {
  const { data, ...hook } = useQuery(GetToolboxIntegrationsCountDocument, {
    variables: { filters },
  });

  const count = data?.toolboxIntegrationsCount.totalCount;

  return {
    ...hook,
    count,
  };
};

export default useGetToolboxIntegrationsCount;
